<template>
  <div>
    <NumeraiTooltip :text="modelId">
      {{ formattedModelId }}
      <v-icon
        v-clipboard:copy="modelId"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        x-small
        >mdi-content-copy</v-icon
      >
    </NumeraiTooltip>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import NumeraiTooltip from '@/components/shared/NumeraiTooltip'

export default {
  components: {
    NumeraiTooltip,
  },
  props: {
    modelId: { type: String, default: null },
  },
  computed: {
    formattedModelId() {
      if (!this.modelId) {
        return '--'
      }
      return _.truncate(this.modelId, { length: 21 })
    },
  },
  methods: {
    ...mapActions(['showSnackBar']),
    copyModelId() {
      navigator.clipboard.writeText(this.modelId)
    },
    onCopy() {
      this.showSnackBar({ msg: 'Model ID copied' })
    },
    onError() {
      this.showSnackBar({ msg: 'Failed to copy ' + this.modelId, time: 0 })
    },
  },
}
</script>
